<template>
  <div>
    <v-dialog :value="exporting" persistent width="500">
      <v-card color="primary" dark class="pa-4">
        <v-card-text style="color:#fff">
          Пожалуйста подождите, идет экспорт...
          <v-progress-linear indeterminate  color="white" class="mb-0"></v-progress-linear>

          <!-- <v-progress-linear class="mt-4" style="color:#25325F" color="white" :value="progress.cur/progress.total*100-5 " height="35" >
            {{ progress.cur-progress.blockSize+1 > 0 ? progress.cur-progress.blockSize+1 : 0 }} - {{ progress.cur }} из {{ progress.total }} кандидатов
          </v-progress-linear> -->

        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="d-flex flex-nowrap align-center" :style="'gap:60px'">
      <div class="d-flex flex-nowrap" :style="'gap:4px'">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" class="d-inline-block">
              <v-btn color="primary" class=" icon px-0" outlined v-bind="attrs" :disabled="!active"
                     :loading="exporting"
                     @click="exportToTable">
                <v-icon :color="active ? 'primary' : '#9BA1B5'">mdi-upload</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Выгрузить в Excel</span>
        </v-tooltip>
        <!-- <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" class="d-inline-block">
              <v-btn color="primary" class="mr-4 icon px-0" outlined v-bind="attrs"
                    @click="$store.commit('notifications/setShowPanelColumns', 'ExcelColumns2')">
                <v-icon color="primary">mdi-table-column-remove</v-icon>
            </v-btn>
          </div>
          </template>
          <span>Настроить выгрузку</span>
        </v-tooltip> -->

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" class="d-inline-block">
              <v-btn v-if="$store.getters['auth/isAllowed']('view_testresultscompliencereport')"
                     color="primary" class="px-0 icon" outlined v-bind="attrs" :disabled="isFilterEmpty" @click="clearFilterAll()">
                <v-icon :color="isFilterEmpty ? '#9BA1B5' : 'primary'">mdi-filter-remove-outline</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Сбросить все фильтры</span>
        </v-tooltip>
      </div>
      <div class="">
          <div class="d-flex flex-nowrap align-center gap col-10" :style="'gap:4px'">
            <span class="">Остатки по тестам</span>
            <custom-select
              class="col-4"
              :dense="true"
              :label="'Остатки по тестам'"
              :outline="true"
              :items="stdTestsItems"
              :offset-y="true"
              :model-value="currentRemainderType"
              @update:model="updateCurrentRemainderType"
            />

            <div class="col-2">
              <v-text-field
                class="font-sm mr-2"
                dense
                hide-details
                outlined
                :rules="rules"
                :value="10"
                :full-width="true"
                readonly
                v-model="remainder"
              />
            </div>

          </div>
      </div>
    </div>

    <!-- <DialogDelete v-model="dialogDeleteShow" /> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ManagersToTable from '@/common/exportExcel/ManagersToTable';
import CustomSelect from '@/components/ui/Select.vue'; // import DialogDelete from '@/components/candidates/DialogDelete';
// import DialogDelete from '@/components/candidates/DialogDelete';

export default {
  props: {
    active: Boolean
  },
  name: 'ManagersTableActions',
  components: {
    CustomSelect,
    // DialogDelete
  },
  data: () => ({
    dialogDeleteShow: false,
    exporting: false,
    rules: [
      value => {
        if (!value) return true;
        const pattern = /\D/;
        return !pattern.test(value) || 'Ввод только чисел';
      }
    ],
    currentRemainderType: { text: 'Все', value: { title: 'Все', id: 0, isStd: false } },
  }),
  computed: {
    ...mapGetters({
      // loading: 'users/candidates/loading',
      isFilterEmpty: 'users/managers/isFilterEmpty',
      stdTests: 'tests/allowedTests',
      user: 'auth/user',
      totalAmount: 'users/managers/totalAmount',
    }),
    stdTestsItems() {
      if (!this.stdTests) {
        return [{ text: 'Все', value: { title: 'Все', id: 0, isStd: false } }];
      }
      return [{ text: 'Все', value: { title: 'Все', id: 0, isStd: false } }, ...this.stdTests.map((item) => ({
            text: item.title,
            value: item,
          })
      )];
    },
    remainder: {
      get() {
        if (this.totalAmount) {
          return this.totalAmount;
        }
          return this.user.licenses_available;
      },
      set(value) {
        return value;
      }

    }

  },
  methods: {
    ...mapActions({
      clearFilterAll: 'users/managers/clearFilterAll',
      loadManagersForExport: 'users/managers/loadManagersForExport',
      getTotalAmount: 'users/managers/getTotalCounters',
    }),
    async exportToTable() {
      this.exporting = true;
      const managers = await this.loadManagersForExport();

      const convertor = new ManagersToTable(managers);
      convertor.toTable();
      this.exporting = false;
    },
    updateCurrentRemainderType(item) {
      this.currentRemainderType = item;
      if (item.id !== 0) {
        const data = { nomenclature_code: item.id };
        data.nomenclature_code = item.id;
        this.getTotalAmount(data);
      } else {
        const data = { nomenclature_code: '' };
        this.getTotalAmount(data);
      }
    },
  },
};
</script>
